import { createFileRoute } from "@tanstack/react-router";
import BreadcrumbJsonLd from "@/components/common/breadcrumbJsonLd";

const BASE_URL = "https://datafirstjobs.com";
const SITE_URL = `${BASE_URL}/resources/guides`;

export const Route = createFileRoute("/resources/guides")({
  head: () => ({
    meta: [
      { title: "Guides | Data First Jobs" },
      {
        name: "description",
        content:
          "Guides and resources for data professionals. Career advice, interview prep, and more.",
      },
      { property: "og:title", content: "Guides | Data First Jobs" },
      {
        property: "og:description",
        content:
          "Guides and resources for data professionals. Career advice, interview prep, and more.",
      },
      { property: "og:url", content: SITE_URL },
    ],
    links: [{ rel: "canonical", href: SITE_URL }],
  }),
  component: GuidesPage,
});

function GuidesPage() {
  return (
    <>
      <BreadcrumbJsonLd
        items={[
          { name: "Home", url: BASE_URL },
          { name: "Guides" },
        ]}
      />
      <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:py-24">
        <h1 className="text-polaris-navy mb-4 text-3xl font-semibold tracking-tight sm:text-4xl">
          Guides
        </h1>
        <p className="text-lg text-gray-600">Coming soon.</p>
      </div>
    </>
  );
}
